export const alert = (theme) => ({
    modal: {
        position: "relative",
    },
    modalHeader: {},
    modalBody: {
        textAlign: "center",
        padding: theme.spacing(7, 8, 8, 8),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        '& a, a:visited': {
          color: theme.customPalette.secondaryYellowYButtons,
        }
    },
    modalText: {
        fontWeight: "700",
        fontSize: "",
    },
    content: {
        display: "flex",
        alignItems: 'center',
        justifyContent: "space-between",
        gap: "20px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            justifyContent: "center",
        },
    },
    icon: {
        width: 62,
        height: 62,
    },
    actions: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: theme.spacing(0, 8, 8, 8),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1, 2, 1, 2),
            justifyContent: "space-around",
            position: "fixed",
            bottom: 0,
            width: "100%",
            borderTop: `1px solid ${theme.customPalette.neutralGy05}`,
        },
        "& button": {
            width: "100%",
        },
    },
    action: {
        "&:nth-child(odd)": {
            [theme.breakpoints.up("md")]: {
                paddingRight: theme.spacing(5),
            },
        },
        "&:only-child": {
            [theme.breakpoints.down("sm")]: {
                width: "100%",
            },
        },
    },
});
